import React from 'react';
import DetailPanel from './../core/detail';
import OfferService from './../../../service/offer';
import UserOffersViewPanel from './view';
import { connect } from 'react-redux';
import mapStateToProps from './../../../store/map/auth-token';
import mapDispatchToProps from './../../../store/map/on-logout';

class _UserOffersPanel extends DetailPanel
{
    constructor(parms)
    {
        super(parms);

        this.loadData = this.loadData.bind(this);
        this.getLoadDataRequest = this.getLoadDataRequest.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
        this.getLoadedDataDetailUi = this.getLoadedDataDetailUi.bind(this);
        this.onAuthError = this.onAuthError.bind(this);
        this.onFatalError = this.onFatalError.bind(this);
        this.onNetworkOffline = this.onNetworkOffline.bind(this);
        this.onLoadDataResponse = this.onLoadDataResponse.bind(this);
    }

    onAuthError()
    {
        this.props.onLogout();
    }

    onFatalError()
    {
        this.props.onUpdateError(true, '');
    }

    onNetworkOffline()
    {
        this.props.onUpdateDeviceOnline(false);
    }

    onLoadDataResponse(response)
    {
        /* istanbul ignore next */
        if(this.props.setHasOffers)
        {
            const hasOffers = response.list.length > 0;
            this.props.setHasOffers(hasOffers);
        }
        super.onLoadDataResponse(response);
    }

    loadData(inputObj)
    {
        super.loadData(inputObj);
        OfferService.getUserListings({
            request: this.getLoadDataRequest(inputObj),
            onResponse: this.onLoadDataResponse,
            onError: this.onLoadDataError,
            authToken: this.props.authToken,
            onAuthError: this.onAuthError,
            onFatalError: this.onFatalError,
            onNetworkOffline: this.onNetworkOffline
        });
    }

    getLoadDataRequest(inputObj)
    {
        return {
            detailsUserId: inputObj.userId,
            page: inputObj.page,
        };
    }

    componentDidMount()
    {
        const userId = this.props.userId;
        this.loadData({
            userId,
            page: 0
        });
    }

    getLoadedDataDetailUi()
    {
        return <UserOffersViewPanel data={this.state.data} />
    }
}

const UserOffersPanel = connect(mapStateToProps, mapDispatchToProps)(_UserOffersPanel);
export default UserOffersPanel;
